import { Component, OnInit, AfterViewInit, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../api.service';
import { CommonService } from '../../common.service';
import { ItemComponent } from "../../app-exercise-work/exercise-work-item/item.component"
@Component({
  selector: 'app-learning-camp-response',
  templateUrl: './learning-camp-response.component.html',
  styleUrls: ['./learning-camp-response.component.css']
})

export class LearningCampResponseComponent implements OnInit, AfterViewInit {
  @ViewChild('child')
  child: ItemComponent
  tabList: any
  className: string = 'response'
  tabNum: number = 0
  isElseTeacherEvaluate: boolean = true //学员作答是否有顾问点评
  myComment: string = "" //我的作答顾问第一次点评
  myQuetionComment: string = "" //我的作答顾问第二次点评
  submitAt: string = "" //学员提交时间
  excellentFlag: number  // 是否是优秀
  isComment: boolean = false //是否有评论
  studentList: any = null//学员作答
  myData: any = null //我的作答
  exerciseGroup: any
  isOpenClass: number = 0; //是否公开课
  constituteId: number
  page: string; //页面
  bodyHeight: string; //答题模块的高度
  appreciateCount: number
  selectedTag: string = ""
  collapse: boolean = true
  relationIdArr: any = [] //学员作答relationId
  answerGroup: any = [] //学员作答答案
  isStudet: boolean = true
  myRelationId: number
  isCollapse: boolean = true;
  theme: string = 'sight'
  appreciateList: any = []
  quertion: any
  isShowToast: boolean = false;
  destext: string = "您已经点过赞了"
  isOpen: number = 0
  data: any = {}
  showCount: boolean = false //在自己没点赞情况下展示点赞次数(大于0展示)
  ifshowData: boolean = false
  isOnlyCamp: boolean = false //只有训练营
  isLastDay: boolean = false //是否是day7
  isFirstDay: any //是否是第一天
  uploadList: any; //上传文件集合
  uploadId: string = ""; //查询上传文件条件
  isShowPreview: boolean = false; //是否显示预览
  previewSource: any; //预览源
  comment: any;//评论内容
  back: any;//评论返回（保存评论内容）
  myCommentList: any;//我的作答评论数据
  relationId: any;
  commentFlag: any;
  learningPathId: any;
  courseId: any;
  text: string = "";
  isShowBackDesc : boolean = false;//是否展示背景描述
  projectId : number;
  courseLearningPathMetaId : number;
  homeworkCloseAtFlag : number = 0;//作答时间是否截止
  homeworkNoAnswer : number = 0;//作业是否未作答
  campId:number=0;
  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private commonService: CommonService,
    private router: Router,) {
  }

  ngOnInit() {
    console.log('进入作答展示');

    this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
    this.tabList = ['我的作答', '学员作答']
    this.campId = Number(localStorage.getItem("campId"))? Number(localStorage.getItem("campId")) : 0;
    this.route.queryParams.subscribe(queryParams => {
      this.tabNum = queryParams['tabNum']
      this.constituteId = queryParams['constituteId']
      this.isOnlyCamp = !!queryParams['onlyCamp'];
      this.back = !!queryParams['back'];
      this.relationId = queryParams['relationId'];
      this.comment = queryParams['comment'];
      this.commentFlag = queryParams['commentFlag'];
      this.learningPathId = queryParams['learningPathId'];
      this.courseId = queryParams['courseId'];
      this.isFirstDay = !!queryParams['firstDay'];
      this.isLastDay = !!queryParams['isLastDay'];
      this.projectId = queryParams['projectId'];
      this.courseLearningPathMetaId = queryParams['courseLearningPathMetaId'];
      this.homeworkCloseAtFlag = Number(queryParams['homeworkCloseAtFlag']);
    })
    this.apiService.learingTime(
      {learningPathMetaId:Number(localStorage.getItem("learningPathMetaId")),
        module:"作业",
        type:1,
        courseUnit:Number(this.constituteId),
        btnName:'作业作答展示',
        userId:localStorage.getItem('userId')})
      .subscribe(result=>{});

    //我的作答答题数据
    let questionGroup = [];
    this.getExerciseDetail(this.constituteId).then(result => {
      this.exerciseGroup= result;
      this.homeworkNoAnswer = this.exerciseGroup.status <= 10 ? 0 : 1;
      if (this.exerciseGroup.questionGroup[0].type == 1) {
        this.exerciseGroup.questionGroup[0].str = this.exerciseGroup.questionGroup[0].answers;
      }
      this.page = 'list';
      //消息通知外链进入
      if (result['campMetaId']) {
        localStorage.setItem("campId", result['campMetaId'])
      }
      if (result['projectId']) {
        localStorage.setItem("skuId", result['projectId'])
      }
      if (result['isOnlyCamp']) {
        localStorage.setItem("onlyCamp", result['isOnlyCamp'])
      }
      this.getLearningPathMetaId();
    }).catch(err => {
      if (err.status === 401) {
        this.router.navigate(['new-login']);
      }
    })

    //获取交互数据
    this.getData();
  }

  ngOnDestroy() {
    console.log('离开作答展示');
    this.apiService.learingTime(
      {learningPathMetaId:Number(localStorage.getItem("learningPathMetaId")),
        module:"作业",
        type:2,
        courseUnit:Number(this.constituteId),
        btnName:'作业作答展示',
        userId:localStorage.getItem('userId')})
      .subscribe(result=>{});
  }

  getData(){
    //获取我的作答数据
    this.getMyAnswerEvaluate(this.constituteId).then(result => {
      this.myData = result
      this.myRelationId = result.relationId
      this.myComment = result.comment
      this.myQuetionComment = result.questioningComment
      this.excellentFlag = result.excellentFlag
      if (result.appreciateCount > 0) {
        this.showCount = true
      }
      //我的作答评论返回(保存评论)
      if (this.tabNum == 0 && this.comment && this.back) {
        if (this.myData.relationId == this.relationId) {
          this.myData.myComment = this.comment
        }
      }
    }).then(() => {
      let arr = [];
      // 获取学员作答数据
      return this.getStudentAnswers(this.constituteId).then(result => {
        //筛选出除了单选题其他答案(实战作业第一题为单选题需要展示出来)
        if(!this.isLastDay){
          arr = result['studentAnswerVOList'].map(item => {
            return item['campExerciseQuestionGroupMetaVO'].questionGroup.filter(questionItem => questionItem.type !== 2);
          })
        }

        //智能作业筛选出除了多选题其他答案（不包含训练营）
        if(this.exerciseGroup.workSource!= "camp"){
          arr = JSON.parse(JSON.stringify(arr)).map(item=>{
            return item.filter(questionItem => questionItem.type !== 4);
          });
        }
        //重新赋值
        if(!this.isLastDay){
          for (let i = 0; i < result['studentAnswerVOList'].length; i++) {
            result['studentAnswerVOList'][i]['campExerciseQuestionGroupMetaVO'].questionGroup = arr[i];
          }
          return this.studentList = result['studentAnswerVOList'].length > 0 ? result['studentAnswerVOList'] : [];
        }else{
          return this.studentList = result['studentAnswerVOList'];
        }

      })
    }).then(() => {
      // 请求查看所有的点赞数据
      return this.getAppreciate().then(result => {
        return this.appreciateList = result
      })
    }).then(() => {
      let self = this;
      self.getAnswerUploadList(Number(self.tabNum));
      self.answerGroup.push(...self.studentList.map(item => item.campExerciseQuestionGroupMetaVO))
      self.relationIdArr.push(...self.answerGroup.map(item => item.relationId))

      this.studentList.forEach(item => {
        item.userClick = false
        if (item['campExerciseQuestionGroupMetaVO'].questionGroup.length > 0 && (item['campExerciseQuestionGroupMetaVO'].questionGroup[0].type == 1 || item['campExerciseQuestionGroupMetaVO'].questionGroup[0].type == 7)) {
          item['campExerciseQuestionGroupMetaVO'].questionGroup[0].str = item['campExerciseQuestionGroupMetaVO'].questionGroup[0].answers
        }
      })
      //学员作答评论返回(保存评论)
      if (this.tabNum == 1 && this.comment && this.back) {
        self.studentList.forEach(item => {
          if (item['userCampExerciseQuestionOperationLogVO'].relationId == this.relationId) {
            item['userCampExerciseQuestionOperationLogVO'].Studentcomment = this.comment;
          }
        })
      }
      self.myData.userClick = false
      self.myData.showOpen = 0;

      //我的作答是否点赞判断
      self.appreciateList.forEach(item => {
        if (item.userCampExerciseQuestionGroupMetasRelationId == self.myData.relationId) {
          self.myData.userClick = true
        }
      })
      this.studentList.forEach(item => {
        item.userClick = false
        item.showCount = false
        item.showOpen = 0;
        item['userCampExerciseQuestionOperationLogVO'].commentCount = 0;
        if (item['userCampExerciseQuestionOperationLogVO'].appreciateCount > 0) {
          item.showCount = true
        }
        if (item['userCampExerciseQuestionOperationLogVO'].studentCommentList == null) {
          item['userCampExerciseQuestionOperationLogVO'].commentCount = 0;
        } else {
          item['userCampExerciseQuestionOperationLogVO'].commentCount = item['userCampExerciseQuestionOperationLogVO'].studentCommentList.length;
        }
        //学员作答点赞情况判断
        self.appreciateList.forEach(itm => {
          if (item['userCampExerciseQuestionOperationLogVO'].relationId == itm.userCampExerciseQuestionGroupMetasRelationId) {
            item.userClick = true
          }
        })
      })
      setTimeout(() => {
        this.judjeHeight();
      }, 100);
      //所有数据是否请求完毕才展示页面
      if (this.studentList || this.myData) {
        this.ifshowData = true
      }
    })
  }

  //背景描述
  backgroundDesc(){
    this.isShowBackDesc = !this.isShowBackDesc;
  }

  getLearningPathMetaId(){
    //根据LearningPathMetaId判断获取是第几单元为了外链进入到作答页面后返回课程列表页是第几单元
    if(this.isFirstDay){
      if(this.campId === 1 || this.campId === 3){
        localStorage.setItem("campCourseDay","Start Day");
      }else{
        localStorage.setItem("campCourseDay","Day1");
      }
    }else if(this.isLastDay){
      if(this.campId === 1){//标准版
        localStorage.setItem("campCourseDay","综合检测");
        localStorage.setItem("learningPathMetasId","-49601");
      }else if(this.campId === 3){//大健康
        localStorage.setItem("campCourseDay","综合检测");
        localStorage.setItem("learningPathMetasId","-429601");
      }else{//互联网
        localStorage.setItem("campCourseDay","Day14");
        localStorage.setItem("learningPathMetasId","-419601");
      }
    }else{
      if(this.learningPathId){
        this.apiService.ajax({
          'type': 'get',
          'url':'/ddilearner/v1/getLearningPathMetaId/'+this.learningPathId
        }).subscribe(result=>{
          switch(result.data){
            case 4192: localStorage.setItem("campCourseDay","Day2&3"); break;
            case 492 || 4292: localStorage.setItem("campCourseDay","沟通原则"); break;
            case 412: localStorage.setItem("campCourseDay","Day4&5"); break;
            case 402 || 422: localStorage.setItem("campCourseDay","互动流程"); break;
            case 416: localStorage.setItem("campCourseDay","Day6&7"); break;
            case 406 || 426: localStorage.setItem("campCourseDay","目标设定"); break;
            case 413: localStorage.setItem("campCourseDay","Day8&9"); break;
            case 403 || 423: localStorage.setItem("campCourseDay","任务授权"); break;
            case 415: localStorage.setItem("campCourseDay","Day10&11"); break;
            case 405 || 425: localStorage.setItem("campCourseDay","辅导他人"); break;
            case 4196: localStorage.setItem("campCourseDay","Day12&13"); break;
            case 496 || 4296: localStorage.setItem("campCourseDay","绩效追踪"); break;
          }
        })
      }
    }
  }


  ngAfterViewInit() {
    this.commonService.initPage({
      'backgroundColor': 'rgba(40,51,130,1)'
    });
  }

  /**
   * 获取答题界面用户上传列表
   * @param tabNum: Number  nav下标
   */
  getAnswerUploadList(tabNum: number): void {
    if (tabNum === 0) {
      let index = this.commonService.getIndexByConditionIdInLists(this.exerciseGroup['questionGroup'], 'type', 5);
      if (index >= 0) {
        this.uploadId = this.exerciseGroup['questionGroup'][index]['campFileUploadIds'] ? this.exerciseGroup['questionGroup'][index]['campFileUploadIds'] : '';
        this.getCampFile({ 'constituteId': this.constituteId, 'questionId': this.exerciseGroup['questionGroup'][index]['questionId'], 'campFileUploadIds': this.uploadId }).then((result) => {
          this.uploadList = result['newFileList'];
        })
      } else {
        this.uploadList = [];
      }
    } 
  }

  async tabIndex(i) {
    this.ifshowData = false;
    this.tabNum = i;
    if (this.tabNum == 0) {
      this.getAnswerUploadList(this.tabNum);
    }
    await this.getData();
    //切换tab时滚动到顶部
    $('.wrap').scrollTop(0);
  }

  //判断高度是否达到可展开收拢高度
  judjeHeight(){
    if(this.tabNum == 0){
      const exerciseWorkBox = document.getElementById(`exercise-work-box-${this.myRelationId}`);
      if (this.myData.comment != '' && this.myData.comment != null && exerciseWorkBox && exerciseWorkBox.offsetHeight>220) {  // 有评论且高度达到
        this.myData.showOpen = 1
      }
    }else if(this.tabNum == 1){
      this.studentList.forEach(item=>{
        // 有评论且高度达到
        const exerciseWorkBox = document.getElementById(`exercise-work-box-${item['userCampExerciseQuestionOperationLogVO'].relationId}`);
        if (item['userCampExerciseQuestionOperationLogVO'].comment != "" && item['userCampExerciseQuestionOperationLogVO'].comment != null && exerciseWorkBox && exerciseWorkBox.offsetHeight>200) {
          item.showOpen = 1
        }
      })
    }
  }

  //我的作答大展开
  myOpen(flag) {
    this.myData.showOpen = flag == 1? 2 : 1;
    //点击收拢的时候回到顶部
    if(this.myData.showOpen == 1){
      //跳转到对应位置
      let ele = document.querySelector(`.my`);
      ele.scrollTop = 0;
    }
  }
  studentOpen(relationId) {
    this.studentList.map(item => {
      if (item['userCampExerciseQuestionOperationLogVO'].relationId == relationId) {
        item.showOpen = item.showOpen == 1? 2 : 1;
      }
    })
    //跳转到对应位置
    let ele = document.querySelector(`.comment_wrap-${relationId}`);
    ele.scrollIntoView();
  }


  //获取收拢展开
  getIsCollapse(event: boolean): void {
    this.isCollapse = event;
  }

  //返回
  exit() {
    let learningPathId = null
    let courseId = null
    this.route.queryParams.subscribe(queryParams => {
      learningPathId = queryParams['learningPathId']
      courseId = queryParams['courseId']
    })

    if (this.isLastDay) {
      //实战作业返回
      this.router.navigate(['course-new', learningPathId, courseId], { queryParams: { isLastDay: 1 } })
    } else if (this.isFirstDay) {
      this.router.navigate(['course-new', learningPathId, courseId], { queryParams: { firstDay: 1 } })
    } else {
      if (learningPathId && courseId) {
        this.router.navigate(['course-new', learningPathId, courseId])
      }else {
        if(this.exerciseGroup.workSource == 'homework'){//项目下的智能作业
          localStorage.removeItem("skuId");
          let link = [];
          if(this.projectId){
            link = ['learning-project',this.projectId];
          }else if(this.courseLearningPathMetaId){
            localStorage.setItem("projectId",this.exerciseGroup.projectId);
            link = ['learning-path',this.courseLearningPathMetaId];
          }
          this.router.navigate(link).then();
        }else{
          this.router.navigate(['exercise-book'])
        }
      }
    }
  }

  setBodyHeight(event: number): void {
    this.bodyHeight = event + 'rem';
  }
  //我的作答点赞
  getMyAppreciate() {
    // this.getMyAnswerEvaluate(this.constituteId).then(result => {
    //   this.myData = result
    //   this.myData.userClick = true
    // })
    this.myData.appreciateCount += 1;
    this.myData.userClick = true;
    //学员作答同一账号同步改变
    // this.studentList.forEach(item=>{
    //  if( item['userCampExerciseQuestionOperationLogVO'].relationId == this.myData.relationId){
    //    console.log(item['userCampExerciseQuestionOperationLogVO'].relationId)
    //    console.log(this.myData.relationId)
    //   item['userCampExerciseQuestionOperationLogVO'].appreciateCount = item['userCampExerciseQuestionOperationLogVO'].appreciateCount += 1
    //   item.userClick = true
    //  }
    // })

  }
  //学员点赞
  getStudentAppreciate(obj) {
    // this.data.relationId = obj.relationId
    // this.data.type = "appreciate"
    // this.giveAppreciate(this.data).then(()=>{
    //   //判断学员点赞和我的作答点赞是否是同一个账号(两边效果同步)
    //   if(obj.relationId == this.myData.relationId){
    //     console.log("我点过赞了")
    //     this.myData.userClick = true
    //     this.myData.appreciateCount +=1
    //   }
    // })


    obj.studentList.map(item => {
      if (item['campExerciseQuestionGroupMetaVO'].relationId == obj.relationId) {
        item['userCampExerciseQuestionOperationLogVO'].appreciateCount = item['userCampExerciseQuestionOperationLogVO'].appreciateCount += 1
        item.userClick = true
      }
    })
    this.studentList = obj.studentList
  }

  getShowToast(flag) {
    this.isShowToast = flag
    if (this.isShowToast) {
      setTimeout(() => {
        this.isShowToast = false
      }, 2000)
    }
  }
  //点赞
  giveAppreciate(data) {
    return this.apiService.ajax({
      'type': 'post',
      'url': '/ddilearner/v2/camp/applicationPractice/saveOperationLog',
      'data': data
    }).toPromise();
  }
  //点赞列表
  getAppreciate() {
    return this.apiService.ajax({
      'type': 'get',
      'url': '/ddilearner/v2/camp/applicationPractice/getOperationLogList/3',
    }).toPromise();
  }

  //获取day7文件
  getCampFile(data) {
    return this.apiService.ajax({
      'type': 'POST',
      'url': '/ddilearner/v2/camp/applicationPractice/actualOperation/getCampFileList',
      'data': data
    }).toPromise();
  }

  //根据试卷ID获取当前试卷所有小题题目
  getExerciseDetail(lpmapcId: number): Promise<any> {
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/camp/applicationPractice/getQuestionGroup/' + lpmapcId,
    }).toPromise();
  }

  //获取我的作答数据
  getMyAnswerEvaluate(constituteId) {
    return this.apiService.ajax({
      'type': 'GET',
      'url': '/ddilearner/v2/camp/applicationPractice/getMyAnswer/' + constituteId
    }).toPromise();
  }

  //获取学员作答数据
  getStudentAnswers(constituteId) {
    return this.apiService.ajax({
      'type': 'GET',
      'url': '/ddilearner/v2/camp/applicationPractice/getStudentAnswerV2/' + constituteId
    }).toPromise();
  }
  /**
   * 预览
   * @param event:Object   子组件传递来的预览对象
   */
  showReview(event): void {
    console.log(11111111111111);
    this.previewSource = event;
    this.isShowPreview = true;
  }

  /**
   * 关闭预览
   */
  closePreview(): void {
    this.isShowPreview = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-response/learning-camp-response.component.ts